import basicConfig from '../config'
const apiConfig = (apiUri) => {
    // const token =
    // 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwOi8vdWF0LWFwaS5udXdhcm9ib3RpY3MuY29tIiwic3ViIjoiYXV0aC51YXQubnV3YXJvYm90aWNzfDE3NDkwNDkwNjcyNiIsImF1ZCI6IkZEN0M3NzIxLTNFMDQtNDY2RC1BRDY1LUE2QjZEQTdDNjVFNyIsImlhdCI6MTU0MjU5NzczMCwiZXhwIjozMDg1MTk2MDYwLCJqdGkiOiIxNjdmZTNjMi03ZDcyLTQyNTQtOTkyMC1jY2NkYzRlZWVhZmUiLCJjb250ZXh0Ijp7InR5cGUiOiJhY2Nlc3MiLCJwcm92aWRlciI6ImRldmVsb3BlcnxmdS5ob25namlhbkBudXdhcm9ib3RpY3MuY29tIn0sInNjb3BlIjoicHJvZmlsZSBhdXRoIGF1dGhfcmVmcmVzaC5nZXQgb3RhIG90YS5nZXQgZGV2ZWxvcGVyIn0.WnB83nJ4WWe_EEAnsWN0S2CBYCM0A2niSykwhgNDkn5VcqG5A_HLOR556-XCfhWlqAiZXh5z0ovUvA1cAY-8DDKdrw1G6CuJXnDuy6DN2-M-j0rwijjYO6__eT0dtwzKmiPJhTkIwCr3-Z5UjJgOzrNSz6_gqGiLgejJ0H0pz1wAhzCjq7yApbaqLzYIptiAk0JpQe2x9k0x3Y29lkqOvH58vAplFQYrB7PT89tvJYNqr0ak816GxEP3m46rHn3IGDvbPq5QF3MQZAMfOeWfgNVg4Pi9pGJJP4YKdM-ucIhOPXGOxoFH1hRWWJklyO7tefSxuClpaWFbHX4odJB7lQ'
    const token =
        localStorage.getItem('token')

    // const headers = { 'authorization': this.$store.state.token }
    const headers = { authorization: token }
    // const domain = 'uat-api.nuwarobotics.com'
    const httpDomain = basicConfig.developerApiDomain
    const apiVer = basicConfig.developerApiVersion // 'v1/'
    // const apiUri = 'developer/lang'
    const path = `${httpDomain}/${apiVer}${apiUri}`
    return {
        headers,
        path
    }
}

export const apiFileConfig = () => {
    const httpDomain = basicConfig.developerUploadApiDomain
    const apiVer = basicConfig.developerApiVersion // 'v1/'
    const apiUri = basicConfig.developerApiUpload // upload
    const path = `${httpDomain}/${apiVer}${apiUri}`
    return path
    // return 'http://uat-file.nuwarobotics.com/v1/upload'
}

export const apiFileApkConfig = () => {
    const httpDomain = basicConfig.developerApiDomain
    const apiVer = basicConfig.developerApiVersion // 'v1/'
    const apiUri = basicConfig.developerApiResource // developer/resource
    const path = `${httpDomain}/${apiVer}${apiUri}`
    return path
    // return 'http://uat-api.nuwarobotics.com/v1/developer/resource'
}

export default apiConfig
